export default function Footer() {
  return (
    <footer className="w-full py-12 px-6 md:px-12 lg:px-24 bg-white border-t border-gray-200">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-base font-light" style={{ color: '#6B7280', fontFamily: "'Inter', sans-serif" }}>
          No spam. No pressure. Just thoughtful resources.
        </p>
        <p className="text-sm font-light mt-4" style={{ color: '#9CA3AF', fontFamily: "'Inter', sans-serif" }}>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="nofollow noopener noreferrer" 
            className="hover:opacity-70 transition-opacity"
          >
            Powered by Readdy
          </a>
        </p>
      </div>
    </footer>
  );
}
